import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Container,
  Dialog,
  DialogContent,
  DialogContentText,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";

import CheckIcon from "@mui/icons-material/Check";
import CodeIcon from '@mui/icons-material/Code';
import DescriptionIcon from "@mui/icons-material/Description";
import { default as EditButton } from "@mui/icons-material/Edit";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import LinkIcon from "@mui/icons-material/Link";
import RepeatIcon from "@mui/icons-material/Repeat";
import TodayIcon from "@mui/icons-material/Today";
import Visibility from "@mui/icons-material/Visibility";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";

import EditNoteIcon from "@mui/icons-material/EditNote";
import Dayjs from "dayjs";
import scheduling from "../Assets/images/icon/schedule_1.gif";
import Output_History_Table from "./Output_History_Table";

import { Editor } from "@monaco-editor/react";
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import axios from "axios";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { runScraperOnce } from "../Api/runScraperOnce";
import apiInstance from "../apiInterceptor";
import CodeDisplayModal from "../Components/CodeDisplayModal";
import DialogHeader from "../Components/DialogHeader";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import HeaderMappingBox from "../Components/HeaderMappingBox";
import { LoadingBtn } from "../Components/LoadingBtn";
import SchedulingScrapers from "../Components/SchedulingScrapers";
import ScrappingCommands from "../Components/ScrappingCommands";
import UpdateUrlModal from "../Components/UpdateUrlModal";
import useCodeEditorStore from "../store/codeEditorStore";
import useHomeStore from "../store/homeStore";
import {
  cronToText,
  dataFormatter,
  dataFormatterOutputHistory,
  dataFormatterSchedules,
  dateFormatter,
  fileName,
  formatDateString,
  formatFrequencyData,
  handleApiError,
  jsonFilePath,
  transformString
} from "../utils";

const cronRegex =
  /^((\*|([0-5]?\d)(-([0-5]?\d))?)(\/([0-5]?\d)?)?)\s+((\*|([01]?[0-9]|2[0-3])(-([01]?[0-9]|2[0-3]))?)(\/([01]?[0-9]|2[0-3]))?)\s+((\*|([0-2]?[0-9]|3[0-1])(-([0-2]?[0-9]|3[0-1]))?)(\/([0-2]?[0-9]|3[0-1]))?)\s+((\*|([1-9]|1[0-2])(-([1-9]|1[0-2]))?)(\/([1-9]|1[0-2]))?)\s+((\*|[0-7]|([0-7](,[0-7])+))(\-([0-7]))?)$/;

const rowHeight = 24;
const headerHeight = 28;
const Frequency = [
  { label: "Select Frequency" },
  { label: "Hourly" },
  { label: "Daily" },
  { label: "Weekly" },
  { label: "Monthly" },
];

const FrequencyHourly = new Array(12).fill(null).map((_, i) => ({
  label: `Every ${i + 1} Hours`,
  hourInterval: i + 1,
}));

const Approved_Details_Page = ({ detailType, version }) => {
  const location = useLocation()
  const session = JSON.parse(localStorage.getItem("session")) || null;

  // check on initial load if session is present, if not redirect login, also stores current url in local storage
  useEffect(() => {
    if (!JSON.parse(localStorage.getItem("session"))) {
      localStorage.setItem("pre-url", location.pathname)
      history.push("/signin");
    }
  }, []);
  const { urlid } = useParams();
  const history = useHistory();
  const pushVersion = version == "v2" ? "" : "v1/";

  // dropdown option
  // radio button
  const [selectedOption, setSelectedOption] = useState("b");
  const [open, setOpen] = useState(false);
  const [openHeaderspopup, setOpenHeaderspopup] = useState(false);
  const [openDownload, setOpenDownload] = useState(false);
  const [usnOpen, setUsnOpen] = useState(false);
  const [openDisableScraper, setOpenDisableScraper] = useState(false);
  const [openRunOnce, setOpenRunOnce] = useState(false);
  const [checkVisible, setCheckVisible] = useState(true);
  const [csure, setSure] = useState(false);
  const [csure2, setSure2] = useState(false);
  const [openResetHeadersconfirmation, setOpenResetHeadersconfirmation] = React.useState(false); 

  const [update, setUpdate] = useState({});
  const [temp, setTemp] = useState("");
  const [disableComment, setDisableComment] = useState("");
  const setHomeRowData = useHomeStore((state) => state.setRowData);

  const [details, setDetails] = useState([]);
  const [ScheduleData, setScheduleData] = useState([]);
  const [activitylogs, setActivitylogs] = useState([]);
  const [StatusHistory,setStatusHistory] = useState("");
  const [SnapshotUrl,setSnapshotUrl] = useState();
  
  const { handleOpenEditor } = useCodeEditorStore()

  const [isSinglePage, setIsSinglePage] = useState(false);
  const [isDownloadingState, setDownloadingState] = useState(false);

  const [fileData, setFileData] = useState({
    data: {},
    id: null,
    type: null,
  });

  const [imageModal, setImageModal] = useState(false)
  const [currImage, setCurrImage] = useState("")

  const [expvalues] = useState({
    date: Dayjs(),
    time: Dayjs(),
    frequency: Frequency[0].label,
    hourInterval: FrequencyHourly[0].hourInterval,
    weeklyInterval: {
      Monday: false,
      Tuesday: false,
      Wednesday: false,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  });

  const [isDownloadable, setIsDownloadable] = useState(false);

  const checkDownload = (data) => {
    if (data.file_download_flag == true) {
      setIsDownloadable(true);
    }
  };

  const [files, setFiles] = useState([]);

  const [schedule, enableScheduler] = useState(false);
  const [refresher, setRefresher] = useState(false);
  const [cronexp, setCronExp] = useState("");
  // row data
  const [rowData, setRowData] = useState();
  const [loading, setLoading] = useState(true);
  const [outputHistoryData, setOutputHistory] = useState();

  const [openal, setOpenal] = React.useState(false);

  const handleClickOpenal = () => {
    if (activitylogs.length == 0) {
      toast.info("No activity logs found")
      return
    }
    setOpenal(true);
  };
  const handleCloseal = () => {
    setOpenal(false);
  };

  const [openUpdateUrl, setOpenUpdateUrl] = useState(false);
  // header row
  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };

  /* modal box1 */
  const [currentJobId, setCurrentJobId] = useState("");

  const handleClickOpenOutputHistory = async (
    value,
    details1,
    type,
    setIsDownloading,
    status,
    snapshot_url
  ) => {
    await fetchJSONOutputHistory(value, details1, type, setIsDownloading);
    setStatusHistory(status)
    setSnapshotUrl(snapshot_url)
    if (type.includes("pre")) setOpenDownload(true);
  };

  useEffect(() => {
    fetchMappingOptions();
    setIsSinglePage(details && details.scraper_type ? true : false);
    if (details && details.headers) {
      setKeyValueMap(details.headers);
      setKeyValueMapFinal(details.headers);
    }
  }, [details]);

  const [dataKeys, setDataKeys] = useState([]);
  const [mappingOptions, setMappingOptions] = useState([]);
  const [keyValueMap, setKeyValueMap] = useState({});
  const [keyValueMapFinal, setKeyValueMapFinal] = useState({});
  // const [isSinglePage, setIsSinglePage] = useState(false)

  const [openResendforPreview, setOpenResendforPreview] = React.useState(false);
  const [currPrompt, setCurrPrompt] = useState("");
  const [currPromptAdd, setCurrPromptAdd] = useState("");
  const [currPromptIndex, setCurrPromptIndex] = useState(null);
  const handleClickOpenResend = async (value, index) => {
    console.log(index);
    setRefresher(!refresher);
    setCurrPrompt(rowData[index - 1].prompts);
    setCurrPromptIndex(index - 1);
    await fetchJSONAPI(value);
    setOpenResendforPreview(true);
  };
  function getValuesFromKeys(keysArray, obj) {
    return keysArray.map(key => obj[key]).filter(value => value !== undefined);
  }

  const handlePromptUpdate = async () => {
    if (currPrompt == "") {
      toast.error("Prompt cannot be empty");
      return;
    }
    let message = "Prompt updated successfully";
    const endp = `${version}/update_prompt_comment_info`;
    console.log(dataKeys, "keys")
    // return
    const data = {
      url_id: urlid,
      step_id: `${currPromptIndex + 1}`,
      update_type: "prompt",
      prompt: currPrompt,
      existing_headers_keys: getValuesFromKeys(dataKeys, keyValueMapFinal),
    };
    if (currPromptAdd != "") {
      data.update_type = "additional_prompt";
      data.additional_prompt = currPromptAdd;
      message = "Additional prompt updated successfully";
      if (currPrompt != rowData[currPromptIndex].prompts) {
        data.update_type = "combined_additional_prompt";
        message = "Prompt & additional prompt updated successfully";
      }
    }
    try {
      const response = await apiInstance.patch(endp, data);

      if (response.statusText === "OK") {
        setCurrPromptAdd("");
        if (openResendforPreview) {
          setOpenResendforPreview(false);
          toast.success(`${message}`);
          setTimeout(() => {
            setRefresher(!refresher);
          }, 2000);
        } else {
          toast.success("Resent for preview");
        }
      }
    } catch (error) {
      setCurrPromptAdd("");
      console.error("Error sending PATCH request:", error);
      handleApiError(error)
    }
  };
  const handleDataKeyChange = (key, value) => {
    setKeyValueMap((prevValues) => ({
      ...prevValues,
      [key]: value,
    }));
  };
  const handleRemoveOption = (labelToRemove) => {
    setMappingOptions((prevOptions) =>
      prevOptions.filter((option) => option.label !== labelToRemove)
    );
  };
  const handleApplyMapping = async (data, value) => {
    if (value == "" || !value) {
      toast.info("Please enter a value first", {
        position: "bottom-right",
      });
      return;
    }
    const specialCharactersRegex = /[!@#\$%\^\&*\)\(+=._-]+/;
    if (specialCharactersRegex.test(value)) {
      toast.info("Special characters not allowed", {
        position: "bottom-right",
      });
      return;
    }
    if (
      !mappingOptions.some((option) => option.label === value.toUpperCase())
    ) {
      //add via api

      const url = `${version}/save_header_details/`;
      try {
        const response = await apiInstance.post(url, {
          project_id: details.project_code,
          header_name: value,
        });
        if (response.statusText === "OK") {
          fetchMappingOptions();
          toast.success("Added sucessfully, select the option again");
        }
      } catch (e) {
        handleApiError(e)
        console.log(e);
      }
    } else {
      toast.info("Entered value already exists", {
        position: "bottom-right",
      });
    }
  };
  function hasDuplicateValues(obj) {
    const valueOccurrences = {};
    for (const key in obj) {
      const value = obj[key];
      if (valueOccurrences[value]) {
        return true;
      } else {
        valueOccurrences[value] = true;
      }
    }

    return false;
  }
  const updateKeyValueMap = async () => {
    const updatedKeyValueMap = { ...keyValueMap };
    for (const key in updatedKeyValueMap) {
      if (
        updatedKeyValueMap.hasOwnProperty(key) &&
        updatedKeyValueMap[key] === ""
      ) {
        delete updatedKeyValueMap[key];
      }
    }
    if (hasDuplicateValues(updatedKeyValueMap)) {
      toast.error("Duplicates not allowed");
      return;
    }
    setKeyValueMap(updatedKeyValueMap);
    const url = `${version}/update_headers/`;
    try {
      const response = await apiInstance.post(url, {
        scraper_id: details.url_id,
        headers: updatedKeyValueMap,
      });

      if (response.statusText === "OK") {
        toast.success("Headers updated successfully");
        setTimeout(() => {
          window.location.reload()
        }, 2000);
        setKeyValueMapFinal(response.data.data.headers);
        setOpenHeaderspopup(false);
      }
    } catch (e) {
      handleApiError(e)
      console.log(e);
    }
  };
  const ResetKeyValueMap = async () => {
    if (Object.values(keyValueMap).every(value => value === "")) {
      toast.error("Column headers are already in their original state. No modifications detected.");
      return;
    }
    const updatedKeyValueMap = { ...keyValueMap };
    for (const key in updatedKeyValueMap) {
      if (
        updatedKeyValueMap.hasOwnProperty(key) &&
        updatedKeyValueMap[key] === ""
      ) {
        delete updatedKeyValueMap[key];
      }
    }
    setKeyValueMap(updatedKeyValueMap);
    const url = `${version}/reset_headers/`;
    try {
      const response = await apiInstance.post(url, {
        scraper_id: details.url_id
      });

      if (response.statusText === "OK") {
        toast.success("Headers reset successfully");
        urlidAPI("approved")
      }
    } catch (e) {
      handleApiError(e)
      console.log(e);
    }
  };

  const fetchMappingOptions = async () => {
    if (!details.project_code) return;
    const url = `${version}/get_headers/${details.project_code}`;
    try {
      const response = await apiInstance.get(url);

      if (response.statusText === "OK") {
        let tempArray = response.data.headers.map((obj) => {
          return { label: obj };
        }).sort((a, b) => a.label.localeCompare(b.label));
        setMappingOptions(tempArray);
      }
    } catch (e) {
      console.log(e);
    }
  };

  /* modal box2 */
  const handleClickOpenHeaderspopup = async (value) => {
    await fetchJSONAPI(value);
    value.status === "approved"
      ? setCheckVisible(false)
      : setCheckVisible(true);
    setOpenHeaderspopup(true);
  };

  // remove modal
  const handleClickOpenDisableScraper = () => {
    setOpenDisableScraper(true);
  };

  const handleClickOpenRunOnce = () => {
    setOpenRunOnce(true);
  };

  const handleCloseDisableScraper = () => {
    setOpenDisableScraper(false);
  };

  const handleCloseUsn = () => {
    let updation = { ...update };
    updation["scrapper_name"] = temp;
    updateAPI(updation);

    setUsnOpen(false);
    setTemp("");
    setSure(false);
    setUpdate({});
  };

  const handleCloseRunOnce = () => {
    setOpenRunOnce(false);
  };

  useEffect(() => {
    if (
      outputHistoryData?.some(
        (data) => data?.status === "Scheduled" || data?.status === "In_progress"
      )
    ) {
      setTimeout(() => {
        urlidAPI("approved");

      }, 300000);
    }
  }, [outputHistoryData]);

  const urlidAPI = async (status) => {
    const endp = `${version}/get_url_data?url_id=${urlid}&status_type=${status}`;
    try {
      const response = await apiInstance.get(endp);

      if (response.statusText === "OK") {
        setOutputHistory(
          dataFormatterOutputHistory(response.data.schedular_history)
        );
        setDetails(response.data);
        setScheduleData(dataFormatterSchedules(response.data.all_schedular_jobs_details));
        setActivitylogs(response.data.activity_logs);
        setRowData(dataFormatter(response.data.xpath_master));
        if (response.data.frequency_type == "crone") {
          setSelectedOption("a");
        } else {
          setSelectedOption("b");
        }
        response.data.transactions
          ? setFiles(jsonFilePath(response.data.transactions))
          : console.log("no transactions");
        checkDownload(response.data);
      }
    } catch (e) {
      setRowData([]);
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = (id) => {
    approveAPI(id);
  };
  const approveAPI = async (tid) => {
    const endp = `${version}/approve-transaction/?transaction_id=${tid}&approved_by=${session.employeeCode}`;
    setFiles((prev) =>
      prev.map((i) => ({
        path: i.path,
        id: i.id,
        status: i.status,
        loader: i.id === tid ? true : false,
      }))
    );
    try {
      const response = await apiInstance.post(endp, null);
      if (response.statusText === "OK") {
        setFiles((prev) =>
          prev.map((i) => ({
            path: i.path,
            id: i.id,
            status: i.id === tid ? "approved" : i.status,
            loader: false,
          }))
        );
        toast.success("Data approved");
        if (!isSinglePage) {
          setOpenHeaderspopup(false);
        }
        setCheckVisible(false);
        urlidAPI("approved")
        // setTimeout(() => {
        //   window.location.reload()
        // }, 1000);
      } else {
        toast.error("Something went wrong, please try again later");
      }
    } catch (e) {
      handleApiError(e)
    }
  };

  useEffect(() => {
    console.log("refreshing due to refresh", refresher);
    urlidAPI("approved");
  }, [urlid, refresher]);

  function getAllUniqueKeys(obj, keys = new Set()) {
    if (typeof obj === "object" && obj !== null) {
      if (Array.isArray(obj)) {
        for (const item of obj) {
          getAllUniqueKeys(item, keys);
        }
      } else {
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            keys.add(key);
            getAllUniqueKeys(obj[key], keys);
          }
        }
      }
    }
    return Array.from(keys);
  }

  const fetchJSONAPI = async (value) => {
    const url = `${version}/preview_json_data`;

    try {
      if (version == "v2") {
        const response = await apiInstance.post(url, {
          prj_id: `${details.project_code}`,
          json_bucket_file_path: value.path,
        });

        if (response.statusText === "OK") {
          setDataKeys(getAllUniqueKeys(response.data.preview));
          setFileData({ data: response.data.preview, id: value.id });
        }
      } else {
        const response = await axios.get(
          process.env.REACT_APP_BUCKET_URL + value.path
        );
        if (response.statusText === "OK") {
          setFileData({ data: response.data, id: value.id });
        }
      }
    } catch (e) {
      console.log(e);
    }
  };


  const handleDownload = (data, fileName, type) => {
    if (version == "v2") {
      if (!data) {
        setDownloadingState(false);
        return;
      }

      const link = document.createElement("a");
      link.href = data;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        setDownloadingState(false);
      }, 1000);
      toast.success("Download started successfully")
      document.body.removeChild(link);

      return;
    }

    const jsonData = JSON.stringify(data);
    let blob = new Blob([jsonData], { type: "application/json" });
    if (type == "logs") {
      blob = new Blob([data], { type: "text/plain" });
    }
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  };

  const extractLogsFromUrl = async (url) => {
    if (!url) return "No logs found";
    const response = await axios.get(url);
    const data = await response.data;
    return data;
  };

  const fetchJSONOutputHistory = async (
    value,
    details1,
    type,
    setIsDownloading
  ) => {
    const url = `${version}/preview_json_data`;

    try {
      if (version == "v2") {
        const response = await apiInstance.post(url, {
          prj_id: `${details1.project_code}`,
          json_bucket_file_path: value.json?.replace(
            process.env.REACT_APP_BUCKET_URL,
            ""
          ),
          log_bucket_file_path: value.log?.replace(
            process.env.REACT_APP_BUCKET_URL,
            ""
          ),
        });
        let tempValue = value.json;
        if (type.includes("log")) {
          tempValue = value.log;
        }
        if (response.statusText === "OK") {
          setIsDownloading(false);
          if (!tempValue) {
            tempValue = "none";
          }
          const parts = tempValue
            ?.replace(process.env.REACT_APP_BUCKET_URL, "")
            .split("/");
          const fileNameDownload = parts[parts.length - 1];
          if (type.includes("json")) {
            setFileData({
              data: response.data.preview,
              id: tempValue.id,
              type: type,
              fileName: fileNameDownload,
              presigned_url: response.data.json_presigned_url,
            });
          } else {
            const logContent = await extractLogsFromUrl(
              response.data.log_presigned_url
            );
            setFileData({
              data: logContent,
              id: tempValue.id,
              type: type,
              fileName: fileNameDownload,
              presigned_url: response.data.log_presigned_url,
            });
          }
          setCheckVisible(false);
          if (!type.includes("pre")) {
            const parts = tempValue
              ?.replace(process.env.REACT_APP_BUCKET_URL, "")
              .split("/");

            const fileNameDownload = parts[parts.length - 1];

            if (type == "logs") {
              handleDownload(
                response.data.log_presigned_url,
                fileNameDownload,
                type
              );
            } else {
              handleDownload(
                response.data.csv_presigned_url
                  ? response.data.csv_presigned_url
                  : response.data.json_presigned_url,
                fileNameDownload,
                type
              );
            }
          }
        }
      } else {
        let tempValue = value.json;
        if (type.includes("log")) {
          tempValue = value.log;
        }

        const response = await axios.get(tempValue);
        if (response.statusText === "OK") {
          const parts = tempValue
            ?.replace(process.env.REACT_APP_BUCKET_URL, "")
            .split("/");
          const fileNameDownload = parts[parts.length - 1];
          setFileData({
            data: response.data,
            id: tempValue.id,
            type: type,
            fileName: fileNameDownload,
          });
          if (!type.includes("pre")) {
            if (type == "logs") {
              handleDownload(response.data, fileNameDownload, type);
            } else {
              handleDownload(response.data.preview, fileNameDownload, type);
            }
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const updateAPI = async (data) => {
    setUpdate((prev) => ({
      ...prev,
      prompt: temp,
    }));
    const endp = `${version}/update_prompt_comment_info`;

    const message =
      data.update_type === "prompt"
        ? "Prompt"
        : data.update_type === "comment"
          ? "Comment"
          : "Scraper Name";

    try {
      const response = await apiInstance.patch(endp, data);
      if (response.statusText === "OK") {
        toast.success(`${message} Succesfully updated`);
        setTimeout(() => {
          setRefresher(!refresher);
        }, 2000);
      } else {
        console.error("Error sending PATCH request:", error);
      }
    } catch (error) {
      handleApiError(error)
      console.error("Error sending PATCH request:", error);
    }
  };

  const reschedulerAPI = async (value) => {
    if (cronRegex.test(value)) {
      const urlcron = encodeURIComponent(value);

      const endp = `${version}/reschedule-task/?job_id=${currentJobId}&reschedule_by=${session.employeeCode}&new_cron_expression=${urlcron}`;
      if (ScheduleData.some(data => data.desc == cronToText(value))) {
        toast.error("Existing crone expression cannot be used")
        return
      }
      try {
        const response = await apiInstance.post(endp, null);
        if (response.statusText === "OK") {
          setRefresher(!refresher);
          toast.success(`Succesfully re-scheduled scraper for ${urlid}`);

          setTimeout(() => {
            window.location.reload()
          }, 2000);
        }
      } catch (e) {
        console.log(e);
        handleApiError(e)
      }
    }
  };

  const removeAPI_schedular = async (job_id = currentJobId, check = false) => {
    const endp = `${version}/stop-task/${job_id}?deleted_by=${session.employeeCode}`;

    try {
      const response = await apiInstance.delete(endp, null);
      if (response.statusText === "OK") {
        if (!check) {
          toast.success("Successfully disabled Schedular scraper");
          setTimeout(() => {
            window.location.reload()
          }, 2000);
        }
      }
    } catch (error) {
      console.error("Error sending PATCH request:", error);
      handleApiError(error)
    }
  };

  const schedulechroneAPI = async (value) => {
    if (cronRegex.test(value)) {
      const urlcron = encodeURIComponent(value);

      const endp = `${version}/schedule-task/?url_id=${urlid}&schedule_by=${session.employeeCode}&chrone_expression=${urlcron}&add_flag=${true}`;
      if (ScheduleData.some(data => data.desc == cronToText(value))) {
        toast.error("Existing crone expression cannot be used")
        return
      }
      try {
        const response = await apiInstance.post(endp, null);
        if (response.statusText === "OK") {
          setRefresher(!refresher);
          toast.success(`Succesfully scheduled scraper for ${urlid}`);

          setTimeout(() => {
            window.location.reload()
          }, 2000);
        }
      } catch (e) {
        console.log(e);
        handleApiError(e)
      }
    }
  };

  function getMostRecentAddedOn(dataArray) {
    if (dataArray.length === 0) {
      return null;
    }

    let mostRecentDate = dataArray[0].added_on;
    for (let i = 1; i < dataArray.length; i++) {
      if (new Date(dataArray[i].added_on) > new Date(mostRecentDate)) {
        mostRecentDate = dataArray[i].added_on;
      }
    }
    return mostRecentDate;
  }

  const removeAPI = async () => {
    const endp = `${version}/delete_scrapper`;
    const data = {
      url_id: urlid,
      emp_code: session.employeeCode,
      disable_flag: true,
      comment: disableComment,
    };
    try {
      const response = await apiInstance.patch(endp, data);
      if (response.statusText === "OK") {
        toast.success("Successfully disabled scraper");
        setTimeout(() => {
          setHomeRowData([]);
          history.push(`/${pushVersion}`, { status: "approved" });
        }, 2000);
      }
    } catch (error) {
      console.error("Error sending PATCH request:", error);
      handleApiError(error)
    }
  };

  useEffect(() => {
    const allFilesApproved = files.every((file) => file.status === "approved");
    if (allFilesApproved && cronRegex.test(cronexp)) {
      enableScheduler(true);
    } else {
      enableScheduler(false);
    }
    if (
      files.some(
        (file) => file.status == "in_progress" || file.status == "pending"
      )
    ) {
      setTimeout(() => {
        urlidAPI("approved");
      }, 500000);
    }
  }, [files, cronexp]);

  useEffect(() => {
    if (details && details.frequency_type === "crone") {
      setCronExp(details.chrone_expression);
    }
  }, [details]);
  // header and row height
  const dataBoxWidth = details.scraper_type != "SINGLE_PAGE" ? 2.4 : 3;

  const getScraperDetails = (details) => {
    if (
      details.urls_data &&
      details.urls_data.length > 0 &&
      details.scraper_type === "PAGINATION"
    ) {
      return transformString(
        `${details.scraper_type} > ${details.pagination_type} > ${details.data_source_type} > MULTI_URL`
      );
    }
  
    if (details.scraper_type === "PAGINATION") {
      return transformString(
        `${details.scraper_type} > ${details.pagination_type} > ${details.data_source_type}`
      );
    }
  
    if (
      details.urls_data &&
      details.urls_data.length > 0 &&
      details.scraper_type === "NO_PAGINATION"
    ) {
      return "No Pagination > Multi Url";
    }
  
    if (details.file_download_flag) {
      return "File Download";
    }
  
    if (details.scraper_type) {
      return transformString(details.scraper_type);
    }
  
    return "";
  };

  const getActionChanges = (activity) => {
    if (activity.action_changes && activity.action_changes.new_changes) {
      if (['RE-SCHEDULE', 'SCHEDULE'].includes(activity.action_type)) {
        return typeof activity.action_changes.new_changes === 'string'
          ? cronToText(activity.action_changes.new_changes) + "."
          : formatFrequencyData(activity.action_changes.new_changes);
      }
      if (activity.action_type === 'RENAME_COLUMN') {
        return "";
      }
      if (activity.action_type === 'CODE_CHANGES') {
        return "";
      }
      return "New " + activity.action_msg + ": " + activity.action_changes.new_changes + ".";
    }
    return "";
  };
  
  return (
    <>
      <Header />
      <Box id="page-container">
        <Container maxWidth>
          <Grid container spacing={1} mb={1} justifyContent="center">
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Box className="fx_sb_mob">
                <Box>
                  <Typography variant="h4" className="col1 fw5 ">
                    {detailType == "approved"
                      ? "Scheduled Scraper Details"
                      : "Today's Scheduled Scraper Details"}
                  </Typography>
                </Box>
                <Box className="fx_fs margin_10">
                  <Box mr={2}>
                    <Button
                      className="approve_btn"
                      onClick={() => {
                        history.push('/')
                      }}
                    >
                      Back
                    </Button>
                  </Box>
                  <Box mr={2}>
                    <Button className="approve_btn" onClick={handleClickOpenDisableScraper}>
                      Disable
                    </Button>
                  </Box>
                  <Box>
                    <Button className="approve_btn" onClick={handleClickOpenal}>
                      Activity Logs
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>

          <Grid container justifyContent="center" spacing={1}>
            <Grid item lg={dataBoxWidth} md={6} sm={6} xs={12}>
              {/* <Link to="#"> */}
              <Box className="cardbx fx_sb" p={0}>
                <Box className='iconbx iconbx_2 cbg2'>
                  <IconButton
                    disableRipple
                    onClick={() => {
                      window.open(details.website_url, "_blank");
                    }}
                  >
                    <LinkIcon fontSize="small" className="wh card_icon4" />
                  </IconButton>
                </Box>
                <Box>
                  <Box className="al_right" m={1} p={1}>
                    <Typography variant="h6" className=" col1 card_title one">
                      {urlid}
                    </Typography>
                    <Typography
                      variant="h5"
                      className=" gray card_subtitle one"
                      title={details.website_url ? details.website_url : "-"}
                    >
                      {details.website_url ? details.website_url : "-"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {/* </Link> */}
            </Grid>

            <Grid item lg={dataBoxWidth} md={6} sm={6} xs={12}>
              {/* <Link to="#"> */}
              <Box className="cardbx fx_sb" p={0}>
                <Box className='iconbx iconbx_2 cbg2'>
                  <IconButton
                    disableRipple
                    onClick={() => {
                      setTemp(
                        details.scraper_name ? details.scraper_name : "-"
                      );
                      setSure(false);
                      setUpdate({
                        url_id: urlid,
                        update_type: "scrapper_name",
                        scrapper_name: details.scraper_name
                          ? details.scraper_name
                          : "-",
                      });
                      setUsnOpen(true);
                    }}
                  >
                    <EditButton
                      fontSize="large"
                      className="wh card_icon4"
                    />
                  </IconButton>
                </Box>
                <Box>
                  <Box className="al_right" m={1} p={1}>
                    <Typography variant="h6" className=" col1 card_title one">
                      Scraper Name{" "}
                    </Typography>
                    <Typography
                      variant="h5"
                      className=" gray card_subtitle one"
                    >
                      {details.scraper_name ? details.scraper_name : "-"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {/* </Link> */}
            </Grid>
            <Grid item lg={dataBoxWidth} md={6} sm={6} xs={12}>
              {/* <Link to="#"> */}
              <Box className="cardbx fx_sb" p={0}>
                <Box className='iconbx iconbx_2 cbg2'>
                  <IconButton disableRipple disabled>
                    <DescriptionIcon
                      fontSize="large"
                      className="wh card_icon4"
                    />
                  </IconButton>
                </Box>
                <Box>
                  <Box className="al_right" m={1} p={1}>
                    <Typography variant="h6" className=" col1 card_title one">
                      Scraper Type
                    </Typography>
                    <Typography
                      variant="h5"
                      className=" gray card_subtitle one"
                    >
                      {getScraperDetails(details)}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {/* </Link> */}
            </Grid>

            <Grid item lg={dataBoxWidth} md={6} sm={6} xs={12}>
              {/* <Link to="#"> */}
              <Box className="cardbx fx_sb" p={0}>
                <Box className='iconbx iconbx_2 cbg2'>
                  <IconButton disableRipple disabled>
                    <TodayIcon fontSize="large" className="wh card_icon4" />
                  </IconButton>
                </Box>
                <Box>
                  <Box className="al_right" m={1} p={1}>
                    <Typography variant="h6" className=" col1 card_title one">
                      Scheduled On
                    </Typography>
                    <Typography
                      variant="h5"
                      className=" gray card_subtitle one"
                    >
                      {details.schedular_history
                        ? dateFormatter(
                          getMostRecentAddedOn(details.schedular_history)
                        )
                        : "-"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {/* </Link> */}
            </Grid>

            {details.scraper_type != "SINGLE_PAGE" && (
              <Grid item lg={dataBoxWidth} md={6} sm={6} xs={12}>
                {/* <Link to="#"> */}
                <Box className="cardbx fx_sb" p={0}>
                  <Box
                    onClick={() => {
                      details.urls_data && details.urls_data.length > 0
                        ? setOpenUpdateUrl(true)
                        : setOpenUpdateUrl(false);
                    }}
                    className='iconbx iconbx_2 cbg2'
                  >
                    <IconButton disableRipple>
                      <EditNoteIcon
                        fontSize="large"
                        className="wh card_icon4"
                      />
                    </IconButton>
                  </Box>
                  <Box>
                    <Box className="al_right" m={1} p={1}>
                      <Typography
                        variant="h6"
                        className=" col1 card_title one"
                      >
                        Number of URLs
                      </Typography>
                      <Typography
                        variant="h5"
                        className=" gray card_subtitle one"
                      >
                        {details.urls_data && details.urls_data.length > 0
                          ? details.urls_data.length
                          : "-"}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                {/* </Link> */}
              </Grid>
            )}
          </Grid>

          <Grid container justifyContent="center" spacing={1}>
            <Grid item lg={7} md={7} sm={12} xs={12}>
              <Box className="whitebx" mt={1}>
                <ScrappingCommands page="approved" temp={temp} urlid={urlid} rowData={rowData} setTemp={setTemp} setUpdate={setUpdate} update={update} updateAPI={updateAPI}/>
              </Box>

              <Box className="whitebx" mt={1}>
                <Output_History_Table
                  response_data={outputHistoryData}
                  on_preview={handleClickOpenOutputHistory}
                  on_download={handleClickOpenOutputHistory}
                  details={details}
                  isDownloadable={isDownloadable}
                />
                {version == "v2" && (
                  <Box mt={2} className="al_right">
                    <Button
                      disabled={files.some((file) => file.status != "approved")}
                      onClick={() => handleClickOpenRunOnce()}
                      className="run_scraper_btn"
                    >
                      {" "}
                      Run Scraper{" "}
                    </Button>
                  </Box>
                )}
              </Box>
            </Grid>

            <Grid item lg={5} md={5} sm={12} xs={12}>
              <Grid container justifyContent="center" spacing={1}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box className="whitebx" mt={1}>
                    <Box className="heading_bx">
                      <Typography variant="h6" className=" col1 card_title ">
                        {isSinglePage
                          ? "Step 1: Data Preview, Approval, and Key Renaming (if necessary)"
                          : "Step 1: Data Preview and Approval"}
                      </Typography>
                    </Box>

                    <Box className="preview_mainbx">
                      {files.map((file, index) =>
                        file.id ? (
                          <Box key={file.id || index} className="preview_bx al_center " p={1}>
                            <Box>
                              <Typography
                                variant="h6"
                                className="one bl xstext  "
                              >
                                {file.status.startsWith("error")
                                  ? "Status: Failed"
                                  : "Status: " +
                                  file.status.charAt(0).toUpperCase() +
                                  file.status.slice(1).toLowerCase()}
                              </Typography>
                              <Typography
                                variant="h6"
                                className="card_preview_heading bl xstext"
                              >
                                {file.status === "approved" ||
                                  file.status === "completed"
                                  ? fileName(file.path)
                                  : file.status.startsWith("error")
                                    ? "Change prompt and try again"
                                    : "Preview In Pending"}
                              </Typography>
                            </Box>
                            <Box mt={2}>
                              <Tooltip
                                title={
                                  file.path
                                    ? file.status === "approved"
                                      ? "Approved"
                                      : "Pending for Approve"
                                    : null
                                }
                                arrow
                                style={{
                                  display:
                                    file.status.startsWith("error") ||
                                      file.status == "pending"
                                      ? "none"
                                      : "inline-flex",
                                }}
                              >
                                {" "}
                                <IconButton
                                  style={{
                                    backgroundColor:
                                      file.status === "approved"
                                        ? "green"
                                        : "#1930ab",
                                  }}
                                  disabled={true}
                                >
                                  {file.loader ? (
                                    // <CircularProgress
                                    //   size={12}
                                    //   style={{ color: "white" }}
                                    // />
                                    <Box className="loadingbtn-container3">
                                      <Box className="dot3" />
                                    </Box>
                                  ) : (
                                    <CheckIcon
                                      className="approve_icon"
                                      style={{ color: "white" }}
                                    />
                                  )}
                                </IconButton>
                              </Tooltip>
                              <Tooltip
                                style={{
                                  display:
                                    file.status.startsWith("error") ||
                                      file.status == "pending"
                                      ? "none"
                                      : "inline-flex",
                                }}
                                title="Preview"
                                arrow
                              >
                                <IconButton
                                  onClick={() => handleClickOpenHeaderspopup(file)}
                                  disabled={file.path ? false : true}
                                  className="eye_btn"
                                >
                                  <Visibility
                                    fontSize="medium"
                                    className="wh approve_icon "
                                  />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Resend for preview" arrow>
                                {file.status == "pending" ? (
                                  <Box ml={4} className="loadingbtn-container2">
                                    <Box className="dot2" />
                                  </Box>
                                ) : (
                                  <IconButton
                                    disabled={
                                      file.status == "in_progress" ||
                                      file.status == "pending"
                                    }
                                    onClick={() => {
                                      handleClickOpenResend(
                                        file,
                                        parseInt(
                                          fileName(
                                            file.path
                                              ? file.path
                                              : file.html_path
                                          ).split("_")[2]
                                        )
                                      );
                                    }}
                                    className="repeat_btn"
                                  >
                                    {file.status == "in_progress" ||
                                      file.status == "pending" ? (
                                      <Box className="loadingbtn-container3">
                                        <Box className="dot3" />
                                      </Box>
                                    ) : (
                                      <RepeatIcon
                                        fontSize="medium"
                                        className="wh approve_icon "
                                      />
                                    )}
                                  </IconButton>
                                )}
                              </Tooltip>
                              {localStorage.getItem("techLead") == "true" &&
                                <Tooltip
                                  style={{
                                    display:
                                      (file.status != "approved" && file.status != "completed")
                                        ? "none"
                                        : "inline-flex",


                                  }}
                                  title="Code"
                                  arrow
                                >
                                  <IconButton
                                    onClick={() => { handleOpenEditor(file, details) }}
                                    disabled={
                                      file.path
                                        ? (file.status != "approved" && file.status != "completed")
                                          ? true
                                          : false
                                        : true
                                    }
                                    className="eye_btn"
                                  >
                                    <CodeIcon
                                      fontSize="medium"
                                      className="wh approve_icon "

                                    />
                                  </IconButton>
                                </Tooltip>
                              }
                            </Box>
                          </Box>
                        ) : null
                      )}
                    </Box>
                  </Box>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box className="whitebx2 schedule">
                    <SchedulingScrapers files={files} session={session} loading={loading} ScheduleData={ScheduleData} schedule={schedule} urlid={urlid} version={version} outputHistoryData={outputHistoryData} schedulechroneAPI={schedulechroneAPI} reschedulerAPI={reschedulerAPI} cronexp={cronexp} setCronExp={setCronExp} currentJobId={currentJobId} setCurrentJobId={setCurrentJobId} />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* modal box2 */}

      <Box className="data preview">
        <Dialog
          open={openHeaderspopup}
          onClose={() => setOpenHeaderspopup(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth={
            details && details.scraper_type && !isDownloadable ? "md" : "xs"
          }
          fullWidth
        >

          <DialogHeader
            heading="Data Preview"
            onClose={() => {
              setKeyValueMap(keyValueMapFinal);
              setOpenHeaderspopup(false);
            }}
          />

          <Box mb={1} className="data_preview">
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <Grid
                  container
                  spacing={2}
                  alignItems="top"
                  justifyContent="center"
                >
                  <Grid
                    item
                    lg={isSinglePage && !isDownloadable ? 6 : 12}
                    md={isSinglePage && !isDownloadable ? 6 : 12}
                    sm={isSinglePage && !isDownloadable ? 6 : 12}
                    xs={12}
                  >
                    <Box className="text_area ">
                      <Box className="input_field datapreview_bx">
                        <TextField
                          id="filled-basic"
                          className="filleddp padding0"
                          variant="filled"
                          multiline
                          
                          name="message"
                          fullWidth
                          value={JSON.stringify(fileData.data, null, 2)}
                          InputProps={{
                            readOnly: true,
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Box>

                      {checkVisible ? (
                        <Box py={1}>
                          <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                            <Box className="checkbox">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name="Are you sure"
                                    checked={csure}
                                    onChange={() => {
                                      setSure(!csure);
                                    }}
                                    size="10px"
                                  />
                                }
                                label={
                                  <span style={{ fontSize: "12px" }}>
                                    Are you sure you want to approve?
                                  </span>
                                }
                              />
                            </Box>
                            <Box>
                              <Button
                                onClick={() => handleApprove(fileData.id)}
                                autoFocus
                                disabled={!csure}
                                className="approve_btn"
                              >
                                Approve
                              </Button>
                            </Box>
                          </Stack>
                        </Box>
                      ) : null}
                    </Box>
                  </Grid>
                  {details && details.scraper_type && !isDownloadable && (
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <Box className="datapreview_bx schedule">
                        {dataKeys.map((data, index) => {
                          const filteredOptions = mappingOptions.filter(
                            (option, index, self) => {
                              const isOptionIncluded = Object.values(keyValueMap).includes(option.label);
                              const isUniqueOption = index === self.findIndex((o) => o.label === option.label);
                              const isSpecialCase = option.label.startsWith(option.label[0]);
                              return (!isOptionIncluded || isSpecialCase) && isUniqueOption;
                            }
                          );
                          return (
                            <HeaderMappingBox
                              data={data}
                              filteredOptions={filteredOptions}
                              keyValueMap={keyValueMap}
                              handleApplyMapping={handleApplyMapping}
                              handleDataKeyChange={handleDataKeyChange}
                              keyValueMapFinal={keyValueMapFinal}
                              handleRemoveOption={handleRemoveOption}
                              mappingOptions={mappingOptions}
                            />
                          );
                        })}
                      </Box>
                      <Box py={1}>
                        <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                          <Box className="checkbox">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="Are you sure"
                                  checked={csure2}
                                  onChange={() => {
                                    setSure2(!csure2);
                                  }}
                                  size="10px"
                                />
                              }
                              label={
                                <span style={{ fontSize: "12px" }}>
                                  Are you sure you want to rename keys?
                                </span>
                              }
                            />
                          </Box>
                          <Box>
                            <Button
                              onClick={() => updateKeyValueMap()}
                              autoFocus
                              disabled={!csure2}
                              className="approve_btn"
                            >
                              Update
                            </Button>
                          </Box>
                          <Box>
                            <Button
                              onClick={() => setOpenResetHeadersconfirmation(true)}
                              autoFocus
                              className="approve_btn"
                            >
                              Reset Headers
                            </Button>
                          </Box>
                        </Stack>
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </DialogContentText>
            </DialogContent>
          </Box>
        </Dialog>
      </Box>

      {/* update scraper name modal */}
      <Box className="data preview">
        <Dialog
          open={usnOpen}
          onClose={() => setUsnOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >

          <DialogHeader
            heading="New Scraper Name :"
            onClose={() => {
              setUsnOpen(false);
            }}
          />


          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box>
                <Box className="txtarea input_field">
                  <TextField
                    id="filled-basic"
                    className="filleddp padding0"
                    variant="filled"
                    multiline
                    minRows={2}
                    name="message"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={temp}
                    onChange={(event) => setTemp(event.target.value)}
                  />
                </Box>
                <Box py={1}>
                  <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                    <Box className="checkbox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="Are you sure"
                            checked={csure}
                            onChange={() => {
                              setSure(!csure);
                            }}
                            size="small"
                          />
                        }
                        label={
                          <span style={{ fontSize: "12px" }}>
                            Are you sure you want to update changes?
                          </span>
                        }
                      />
                    </Box>
                    <Box>
                      <Button
                        onClick={() => {
                          handleCloseUsn();
                        }}
                        autoFocus
                        className="approve_btn"
                        disabled={!csure}
                      >
                        Update
                      </Button>
                    </Box>
                  </Stack>
                </Box>
              </Box>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </Box>

      {details.scraper_type != "SINGLE_PAGE" && (
        <UpdateUrlModal
          open={openUpdateUrl}
          setOpen={setOpenUpdateUrl}
          details={details}
          version={version}
          refresh={refresher}
          setRefresh={setRefresher}
        />
      )}
      {/* Modal Box for Disable */}

      <Box className="comment">
        <Dialog
          open={openDisableScraper}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >
          <DialogHeader
            heading="Comment"
            onClose={() => {
              setOpenDisableScraper(false);
            }}
          />

          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="text_area">
                <Box className="input_field">
                  <TextField
                    id="filled-basic"
                    className="filleddp padding0"
                    variant="filled"
                    multiline
                    name="message"
                    placeholder="Comment"
                    fullWidth
                    value={disableComment}
                    onChange={(event) => setDisableComment(event.target.value)}
                  />
                </Box>
              </Box>
              <Box py={1}>
                <Stack direction={"row"} spacing={1} alignItems={"center"} justifyContent={"space-between"}>
                  <Box className="checkbox">
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="Are you sure"
                          checked={csure}
                          onChange={() => {
                            setSure(!csure);
                          }}
                          size="10px"
                        />
                      }
                      label={
                        <span style={{ fontSize: "12px" }}>
                          Are you sure you want to disable scraper?
                        </span>
                      }
                    />
                  </Box>
                  <Box>
                    <Button
                      onClick={() => {
                        ScheduleData.forEach(async (data) => {
                          if (data.next) {
                            await removeAPI_schedular(data.job_id, true)
                          }
                        })
                        removeAPI();
                        handleCloseDisableScraper();
                      }}
                      autoFocus
                      className="approve_btn"
                      disabled={!csure || disableComment === ""}
                    >
                      Disable
                    </Button>
                  </Box>
                </Stack>
              </Box>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </Box>

      {/* modal box download */}

      <Box className="data preview">
        <Dialog
          open={openDownload}
          onClose={() => setOpenDownload(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="md"
          fullWidth
        >

          <DialogHeader
            heading={fileData.type && fileData.type.includes("logs") ? "Logs" : "Data Preview"}
            onClose={() => {
              setOpenDownload(false);
            }}
          />

          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box>
                <Editor
                  height="400px"
                  defaultLanguage="text"
                  value={
                    fileData.type && fileData.type.includes("logs")
                      ? fileData.data
                      : JSON.stringify(fileData.data, null, 2)
                  }
                  options={{
                    minimap: {
                      enabled: false, // Disable the minimap
                    }, wordWrap: 'on'
                  }}
                />

                {fileData.presigned_url != undefined && (
                  <Box className="al_right" py={1} display="flex" flexDirection="row" justifyContent="flex-end" gap={2}>
                  {fileData.type.includes("logs") &&  
                  StatusHistory === "Failed" && SnapshotUrl && (
                      <Box>
                      <Button
                        onClick={() =>{
                          setCurrImage(SnapshotUrl)
                          setImageModal(true)
                        } 
                      }
                        className="approve_btn"
                      >
                        Check Snapshot
                      </Button>
                    </Box>)}
                    <Box>
                      {isDownloadingState ? (
                        <LoadingBtn />
                      ) : (
                        <Button
                          autoFocus
                          className="approve_btn"
                          onClick={() => {
                            setDownloadingState(true);
                            handleDownload(
                              fileData.presigned_url,
                              fileData.fileName,
                              fileData.type
                            );
                          }}
                        >
                          Download
                        </Button>
                      )}
                    </Box>
                  </Box>
                )}
              </Box>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </Box>


      <Box className="data preview">
        <Dialog
          open={imageModal}
          onClose={() => {
            setImageModal(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            style: {
              width: '1200px', // Set the desired width here
              height: '600px', // Set the desired height here (80% of the viewport height)
              maxWidth: 'none', // Ensures that maxWidth isn't limited by the `maxWidth` prop
            },
          }}

        >

          <IconButton
            aria-label="close"
            onClick={() => {
              setImageModal(false);
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <HighlightOffIcon fontSize="small" className="gray" />
          </IconButton>
          <DialogContent >
            <DialogContentText id="alert-dialog-description">
              <Box className="  al_center" my={4}>
                <Box mb={2}>

                  <img
                    src={currImage}
                    alt="preview"

                    style={{
                      width: '100%',    // Ensure the image takes up the full width
                      height: 'auto',   // Ensure the image takes up the full height

                    }}
                  />

                </Box>

              </Box>
            </DialogContentText>
          </DialogContent>

        </Dialog>
      </Box>

      <CodeDisplayModal />
      {/* Run Once Modal */}
      <Box className="data preview">
        <Dialog
          open={openRunOnce}
          onClose={handleCloseRunOnce}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="al_center" my={4}>
                <Box mb={2}>
                  <Box>
                    <img
                      src={scheduling}
                      alt="Re-Schedule"
                      className="remove_icon_gif"
                    />
                  </Box>
                </Box>
                <Typography variant="h5" className="gray fw6">
                  Are you sure you want to run scraper once ?
                </Typography>
              </Box>
              <Box py={1}>
                <Stack direction={"row"} spacing={1} alignItems={"center"} justifyContent={"center"}>
                  <Button
                    onClick={async () => {
                      await runScraperOnce(urlid, session.employeeCode, version);
                      setOpenRunOnce(false);
                      urlidAPI("approved");
                    }}
                    autoFocus
                    className="approve_btn"
                  >
                    Run Once
                  </Button>
                  <Button
                    onClick={handleCloseRunOnce}
                    autoFocus
                    className="cancel_btn"
                  >
                    Cancel
                  </Button>
                </Stack>

              </Box>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </Box >

      {/* Reset Headers Confirmation*/}
      < Box className="data preview" >
        <Dialog
          open={openResetHeadersconfirmation}
          onClose={() => {
            setOpenResetHeadersconfirmation(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="al_center" my={4}>
                <Box mb={2}>
                  <Box>
                    <img
                      src={scheduling}
                      alt="Reset Headers"
                      className="remove_icon_gif"
                    />
                  </Box>
                </Box>
                <Typography variant="h5" className="gray fw6">
                  Are you sure you want to reset attributes keys?
                </Typography>
              </Box>
              <Box className="fx_c" mb={2}>
                <Box mr={1}>
                  <Button
                    onClick={() => {
                      ResetKeyValueMap();
                      setOpenResetHeadersconfirmation(false);
                    }}
                    autoFocus
                    className="approve_btn"
                  >
                    Ok
                  </Button>
                </Box>
                <Box>
                  <Button
                    onClick={() => {
                      setOpenResetHeadersconfirmation(false);
                    }}
                    autoFocus
                    className="cancel_btn"
                  >
                    Cancel
                  </Button>
                </Box>
              </Box>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </Box >

      {/* activity log */}

        <Dialog
          onClose={handleCloseal}
          aria-labelledby="customized-dialog-title"
          open={openal}
          maxWidth="xs"
          fullWidth
        >

          <DialogHeader
            heading="Activity Logs"
            onClose={handleCloseal}
          />

          <DialogContent className="history_drawer">
            <Box>
              <List>
                {activitylogs.map((activity, index) => (
                  <>
                    <ListItem key={index} disablePadding>
                      <ListItemAvatar>
                        <Avatar style={{ backgroundColor: "#00b0f0" }}>
                          <QueryBuilderIcon fontSize="small" /> {/* You can replace ImageIcon with the desired icon */}
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                            <Tooltip arrow title={<>
                              {(activity.action_by_emp_id === session.employeeCode ? "You" : activity.action_by)}{" "}
                              <strong>
                                {activity.action_type === "RENAME_COLUMN" ? (
                                  <>
                                    {"updated output preview keys"}
                                    <br />
                                    <br />
                                    <span style={{ marginTop: '3px' }}>
                                      {`Updated headers:  ${activity.action_changes ? JSON.stringify(activity.action_changes.new_changes) : '-'
                                        }`}
                                    </span>
                                  </>
                                ) : (
                                  activity.action_msg
                                )}
                              </strong>
                              {"."}
                              {getActionChanges(activity)}
                            </>}>
                              <Typography variant='h6' className='bl xtext lg2 fw4 one'>
                                {(activity.action_by_emp_id === session.employeeCode ? "You" : activity.action_by)}{" "}
                                <strong>
                                  {activity.action_type === "RENAME_COLUMN" ? (
                                    <>
                                      {"updated output preview keys"}
                                      <br />
                                      <br />
                                      <span style={{ marginTop: '3px' }}>
                                        {`Updated headers:  ${activity.action_changes ? JSON.stringify(activity.action_changes.new_changes) : '-'
                                          }`}
                                      </span>
                                    </>
                                  ) : (
                                    activity.action_msg
                                  )}
                                </strong>
                                {"."}
                                {getActionChanges(activity)}
                              </Typography>
                            </Tooltip>
                        }
                        secondary={
                            <Typography variant='h6' className='bl xtext lg fw4'>
                              {activity.action_on.includes('T') ? dateFormatter(activity.action_on) : formatDateString(activity.action_on)}
                            </Typography>
                        }
                      />
                    </ListItem>
                    <Box py={'4px'}>
                      <Divider />
                    </Box>
                  </>
                ))}
              </List>
            </Box>
          </DialogContent>
        </Dialog>
      {/* Resend For Preview */}
      < Box className="data preview" >
        <Dialog
          open={openResendforPreview}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >
          <DialogHeader
            heading="Data Preview"
            onClose={() => {
              setOpenResendforPreview(false);
            }}
          />

          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="text_area">
                <Box className="input_field">
                  <TextField
                    id="filled-basic"
                    className="filleddp padding0"
                    variant="filled"
                    multiline
                    minRows={4}
                    maxRows={4}
                    name="message"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={JSON.stringify(fileData.data, null, 2)}
                  />
                </Box>
                <Box pt={2}>
                  <Typography variant="h6" className=" col1 card_title " gutterBottom>
                    Existing Prompt <span style={{ color: "red" }}>*</span>
                  </Typography>
                </Box>
                <Box className="input_field">
                  <TextField
                    id="filled-basic"
                    className="filleddp padding0"
                    variant="filled"
                    name="message"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={currPrompt}
                    disabled={currPrompt == "Downloadable Links" || currPrompt == "LIST_ITEM" || currPrompt == "DATA_SOURCE" || currPrompt == "PAGINATION_SOURCE" || currPrompt == "Hyperlinks"}
                    onChange={(event) => setCurrPrompt(event.target.value)}
                  />
                </Box>
                <Box pt={2}>
                  <Typography variant="h6" className=" col1 card_title " gutterBottom>
                    Additional Prompt (Optional)
                  </Typography>
                </Box>
                <Box className="input_field">
                  <TextField
                    id="filled-basic"
                    className="filleddp padding0"
                    variant="filled"
                    multiline
                    minRows={1}
                    name="message"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}

                    value={currPromptAdd}
                    onChange={(event) => setCurrPromptAdd(event.target.value)}
                  />
                </Box>
                <Box py={1}>
                  <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                    <Box className="checkbox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="Are you sure"
                            checked={csure}
                            onChange={() => {
                              setSure(!csure);
                            }}
                            size="small"
                          />
                        }
                        label={
                          <span style={{ fontSize: "12px" }}>
                            Are you sure you want to update?
                          </span>
                        }
                      />
                    </Box>
                    <Box>
                      <Button
                        onClick={() => {
                          handlePromptUpdate();
                        }}
                        autoFocus
                        className="approve_btn"
                        disabled={!csure}
                      >
                        Update & Resend
                      </Button>
                    </Box>
                  </Stack>
                </Box>
              </Box>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </Box >
      <ToastContainer
        position="top-center"
        style={{ fontSize: "16px", width: "600px", height: "200px" }}
      />
      <Footer />
    </>
  );
};

export default Approved_Details_Page;
